<template>
  <div>
    <Modal v-model="isShow" @on-ok="ok" :loading="loading" :mask-closable="false">
      <h3 slot="header" class="modal-header">看房配置</h3>
      <Row class="row" >
        <Col span="4" >类别</Col>
        <Col span="4">图片</Col>
        <Col span="12">链接</Col>
        <Col span="4">操作</Col>
      </Row>
      <Row class="row" v-for="(item,index) in data " :key="item.fid">
        <Col span="4">
          <Input class="width100" v-model="item.labelName" readonly/>
        </Col>
        <Col span="4">
          <a @click.stop="uploadImg(item)">配置</a>
        </Col>
        <Col span="12">
          <Input class="width150" v-model="item.link"/>
        </Col>
        <Col span="4">
          <a @click.stop="deleteItem(item,index)">删除</a>
        </Col>
      </Row>
      <!--<div class="mt20">-->
        <!--<a @click.stop="addItem">+ 添加</a>-->
      <!--</div>-->
      <img-upload :n="uploadN" :fid="configFid" :orderId="orderId" @pic="pic" :pics="pics" :link="1" :projectFid="projectFid"></img-upload>
      <!--<div slot="footer"></div>-->
    </Modal>
  </div>

</template>

<script>
  // import {labelgetConfigImg} from "../../../../api/projectConfig";
  import ImgUpload from './ImgUpload'
  import {labellist,labeledit,labelremove} from "../../../../api/projectConfig";
  import {isType} from "../../../../utils/public";

  export default {
    name: "HouseConfig",
    components:{
      ImgUpload
    },
    props:{
      n: {
        type: Number,
        default: 0
      },
      fid:{
        type:String,
        default:''
      },
      projectFid:{
        type:String,
        default:''

      }
    },
    watch:{
      n(){
        this.labellist()
        this.isShow=true
      },
      // fid(){
      //   this.labellist()
      // }
    },
    data(){
      return {
        uploadN:0,
        isShow:false,
        data:[],
        loading:true,
        orderId:0,
        configFid:'',
        pics:[]
      }
    },
    methods:{
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      addItem(){
        this.data.push({
          "fid": "",
          "labelName": "",
          "picUrl":[],
          "link": "",
          "labelType": 8,
          "moduleId": ""
        })
      },
      labellist(){
        if(!this.fid){
          return
        }
        let params={
          moduleFid:this.fid,
          type:8
        }
        labellist(params).then(res=>{
          this.data=res.data
        })

      },
      uploadImg(item){
        this.pics = []
        var order = item.labelOrder
        if(!order){
          this.$Message.info('请先添加排序')
          return
        }
        if((+order).toString()==='NaN' || !isType('Number',+order)){
          this.$Message.info('排序字段为数字')
          return
        }
        let labelOrder = this.data.filter(item => item.labelOrder==order)
        if(labelOrder.length > 1 ){
          this.$Message.info('排序字段不能重复')
          return
        }
        if(!item.picUrl){

        }else{
          this.pics = item.picUrl
        }
        this.configFid=item.fid
        this.orderId=order
        this.uploadN++
      },

      deleteItem(item,index){

        this.$Modal.confirm({
          content: '<p>确认删除？</p>',
          onOk: () => {
            if(item.fid){
              let params={
                fid:item.fid
              }
              labelremove(params).then(res=>{
                this.$Message.success('删除成功')
                this.data.splice(index,1)
              })
            }
            else {
              this.data.splice(index,1)
            }
          }
        })
      },
      ok(){
        for (var key=0;key<this.data.length;key++){
          if(!this.data[key].fid && !this.data[key].picUrl && !this.data[key].link){
            this.data.splice(key,1)
            key-=1;
          }
        }
        if(this.data.length < 1){
          this.$Message.success('标签保存成功')
          this.changeLoading()
          this.isShow = false
          return
        }
        let params={
          moduleFid:this.fid,
          labelEntities:this.data,
          proHouseTypeFid:this.projectFid,
          type:1
        }
        labeledit(params).then(res=>{
          this.$Message.success('标签保存成功')
          this.changeLoading()
          this.isShow = false
        }).catch(error=>{})
      },
      pic(data){
        if(data.length < 1){
          return
        }
        this.pics = []
        var order = data[0].order
        let labelOrder = this.data.filter(item => {return item.labelOrder==order})
        labelOrder[0].picUrl = []
        data.forEach(item => {
          labelOrder[0].picUrl.push(item)
        })
      },

    },
    created(){
      // this.labellist()
    }

  }
</script>

<style scoped>
  .width150{
    width: 100px;
  }
  .width80{
    width: 50px;
  }
  .row {
    text-align: center;
    /*margin-bottom: 10px;*/
    line-height: 32px;

    border-left: 1px solid rgb(222, 222, 222);
    border-right: 1px solid rgb(222, 222, 222);
    border-bottom: 1px solid rgb(222, 222, 222);
    padding: 7px;
  }

  .row:first-child {
    border-top: 1px solid rgb(222, 222, 222);
    background-color: rgb(248, 248, 248);
    padding: 5px;
  }

</style>
